import React, { useState, useEffect, Fragment } from 'react';
import { Link } from 'react-router-dom';
import moment from "moment-jalaali";
import Button from '@material-ui/core/Button';
import { Scrollbar } from "react-scrollbars-custom";
import { base_url } from '../Api/Api';
import EntrnaceHeader from './EntranceHeader';
import PulseLoader from "react-spinners/PulseLoader";
import Popup from '../Common/Popup';
import Cookies from 'universal-cookie';

const Confim = (props) => {

    const [loading, setLoading] = useState(false)
    const [data, setData] = useState({
        fName: '',
        lName: '',
        nationalCode: '',
        birthdatDate: '',
        province: '',
        provinceId: '',
        city: '',
        cityId: '',
        nameShop: '',
        nameShopId: '',
        manager: ''
    })
    const [state, setState] = useState({
        loading: false,
        dateValue: null,
        loader: false,
        statusDisAccount: false
    })

    useEffect(() => {

        const infoPerson = JSON.parse(localStorage.getItem('personalInfo'))
        const infoShop = JSON.parse(localStorage.getItem('shopInfo'))
        let temp = moment(infoPerson.dateBirthday)

        setData({
            fName: infoPerson.firstName,
            lName: infoPerson.lastName,
            nationalCode: infoPerson.nationalCode,
            birthdatDate: temp.format('jYYYY/jM/jD'),
            province: infoShop.province.name,
            provinceId: infoShop.province.id,
            city: infoShop.city.name,
            cityId: infoShop.city.id,
            nameShop: infoShop.shop.name,
            nameShopId: infoShop.shop.id,
            manager: infoShop.manager
        })

        setTimeout(() => {
            setLoading(true)
        }, 300);
    }, [])

    const changeRoutes = (id) => {
        setLoading(false)
        setTimeout(() => {
            props.history.push(`/entrance/step${id}`)
        }, 400);
    }

    const contniue = () => {

        setState({
            ...state,
            loader: true,
        })
        const Data = {
            'mobile': JSON.parse(localStorage.getItem('phoneNumber')),
            'code': JSON.parse(localStorage.getItem('verfCode')),
            'name': data.fName,
            'last_name': data.lName,
            'national_code': data.nationalCode,
            'birthdate': data.birthdatDate,
            'store_id': data.nameShopId,
            'is_manager': data.manager ? 1 : 0,
            'webpush_id': localStorage.getItem('gcm_id')
        }

        base_url.post("fillprofile", Data)
            .then(response => {
                setState({
                    ...state,
                    loader: false,
                    tokenUser: response.data.token,
                    statusDisAccount: true
                })
            })
    }

    const confirmData = () => {
        setState({
            ...state,
            statusDisAccount: false
        })
        const cookies = new Cookies()
        cookies.set("api_key", state.tokenUser, {
            maxAge: 604800,
            path: "/",
        })
        props.history.push('/')
        window.location.reload()
    }

    return (
        <Fragment>
            <EntrnaceHeader />
            <Popup active={state.statusDisAccount} class="login-popup">
                <i className="icon-bell-fill"></i>
                <span>ثبت نام شما با موفقیت انجام شد بعد از تایید ادمین حساب کاربری شما فعال خواهد شد.</span>
                <div className="btn-base btn-black btn-sircle">
                    <Button variant="contained"
                        onClick={confirmData} >تایید</Button>
                </div>
            </Popup>
            <div className={`entrnc-web pesronal-info confirm-info ${loading ? 'active' : ''}`}>
                <div className="bx-info">
                    <Scrollbar>
                        <div className="titles-style-1">
                            <h4>تایید اطلاعات</h4>
                        </div>

                        <div className="step-progress">
                            <span className="active"></span>
                            <span className="active"></span>
                            <span className="active"></span>
                        </div>
                        <div className="confirm-information">

                            <div className="card-info">
                                <div className="row-card-ttl">
                                    <span>اطلاعات شخصی </span>
                                </div>
                                <div className="row-card">
                                    <div className="item-card">
                                        <span>نام</span>
                                        <strong>{data.fName}</strong>
                                    </div>
                                    <div className="item-card">
                                        <span>نام خانوادگی</span>
                                        <strong>{data.lName}</strong>
                                    </div>
                                </div>
                                <div className="row-card">
                                    <div className="item-card">
                                        <span>کد ملی</span>
                                        <strong>{data.nationalCode}</strong>
                                    </div>
                                    <div className="item-card">
                                        <span>تاریخ تولد</span>
                                        <strong>{data.birthdatDate}</strong>
                                    </div>
                                </div>
                                <div className="edit-icon">
                                    <button
                                        type="button"
                                        onClick={() => changeRoutes('3')} >
                                        <i className="icon-edit"></i><span>ویرایش</span>
                                    </button>
                                </div>
                            </div>
                            <div className="card-info">
                                <div className="row-card-ttl">
                                    <span>اطلاعات فروشگاه </span>
                                </div>
                                <div className="row-card">
                                    <div className="item-card">
                                        <span>استان</span>
                                        <strong>{data.province}</strong>
                                    </div>
                                    <div className="item-card">
                                        <span>شهر</span>
                                        <strong>{data.city}</strong>
                                    </div>
                                </div>
                                <div className="row-card">
                                    <div className="item-card">
                                        <span>نام فروشگاه</span>
                                        <strong>{data.nameShop}</strong>
                                    </div>
                                    <div className="item-card">
                                        <span>مدیر فروشگاه هستم</span>
                                        <strong>
                                            {
                                                data.manager ?
                                                    'بلی'
                                                    :
                                                    'خیر'
                                            }
                                        </strong>
                                    </div>
                                </div>
                                <div className="edit-icon">
                                    <button
                                        type="button"
                                        onClick={() => changeRoutes('4')} >
                                        <i className="icon-edit"></i><span>ویرایش</span>
                                    </button>
                                </div>
                            </div>

                        </div>
                        <div className="btn-base btn-black btn-sircle">
                            {state.loader ?
                                <Button
                                    variant="contained">
                                    <PulseLoader
                                        color="#fff"
                                        loading={true}
                                        size={12} />
                                </Button>
                                :
                                <Button
                                    variant="contained"
                                    onClick={contniue}>تایید نهایی</Button>
                            }
                        </div>
                    </Scrollbar>
                </div>
            </div >
        </Fragment>
    );
}

export default Confim;